var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.317185 0H13.6811C13.857 0 13.9995 0.143868 13.9995 0.321432C13.9995 0.419185 13.9564 0.506702 13.8881 0.565698L8.55381 5.92321V10.5209C8.55381 10.6482 8.48055 10.7581 8.37425 10.8102L5.85794 12.2768C5.70607 12.3654 5.5117 12.3131 5.42363 12.1599C5.39458 12.1092 5.38079 12.0539 5.38091 11.9991H5.38022V5.92217L0.0919406 0.547527C-0.0317899 0.421945 -0.0312203 0.218965 0.0931938 0.0941871C0.155173 0.0319707 0.236179 0.000920021 0.317185 0.000920021V0ZM12.9107 0.64298H1.0811L5.90705 5.54773C5.97449 5.60661 6.0171 5.69378 6.0171 5.79084V11.4431L7.91681 10.3362V5.79084H7.91772C7.91772 5.7085 7.94894 5.62616 8.01138 5.56348L12.9107 0.64298Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12.32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.726830d6fae7b3262669720feab47b7d.svg";
export { ForwardRef as ReactComponent };